import React from 'react';
import { string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ContentGalleryCard as ContentGalleryCardComponent } from '@thd-olt-component-react/content-gallery-card';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function ContentGalleryCard({
  id,
  layoutRendererPrerenderedChildIndex
}) {
  const componentPosition = layoutRendererPrerenderedChildIndex ? layoutRendererPrerenderedChildIndex + 1 : 1;

  return (
    <ErrorBoundary name="content_gallery_card">
      <QueryProvider key={id} cacheKey="content-gallery-card-cache">
        <ContentGalleryCardComponent
          componentId={id}
          componentClass="Gallery"
          componentPosition={componentPosition}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

ContentGalleryCard.propTypes = {
  id: string,
  layoutRendererPrerenderedChildIndex: number,
};

ContentGalleryCard.defaultProps = {
  id: undefined,
  layoutRendererPrerenderedChildIndex: undefined,
};
